import React, {useEffect, useState} from 'react';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import NavbarApp from './components/Navbar/NavbarApp';
import RouteLinks from './components/RouteLinks/RouteLinks';

import 'bootstrap/dist/css/bootstrap.css';

import "primeicons/primeicons.css";

export default function App() {
 
  useEffect(() => {
  }, []);

  return (
    <>
      <React.StrictMode>
        <BrowserRouter>
          <NavbarApp />
          <RouteLinks />
        </BrowserRouter>
      </React.StrictMode>
    </>
  );
}